import type { GridApi, GridOptions } from 'ag-grid-community';
import { useHierarchicalVariantSpecs } from './useHierarchicalVariantOptions';
import { useRowGroupVariantSpecs } from './useRowGroupVariantOptions';

interface UsePositionsSubAccountsBlotterVariantsParams {
  hierarchical: boolean;
  refreshClientSideRowModel: GridApi['refreshClientSideRowModel'] | undefined;
}

interface UsePositionsSubAccountsBlotterVariantsOutput {
  blotterSpecToUse: {
    gridOptionsOverlay: Pick<
      GridOptions,
      | 'groupDisplayType'
      | 'groupHideParentOfSingleChild'
      | 'autoGroupColumnDef'
      | 'rowGroupPanelShow'
      | 'getDataPath'
      | 'showOpenedGroup'
      | 'treeData'
    >;
  };
}

/**
 * Resolves row-group vs hierarchical grid options for sub-account positions blotters.
 */
export function usePositionsSubAccountsBlotterVariants({
  hierarchical,
  refreshClientSideRowModel,
}: UsePositionsSubAccountsBlotterVariantsParams): UsePositionsSubAccountsBlotterVariantsOutput {
  const rowGroupBlotterVariantSpecs = useRowGroupVariantSpecs();
  const hierarchicalBlotterVariantSpecs = useHierarchicalVariantSpecs({
    hierarchical,
    refreshClientSideRowModel,
  });

  const blotterSpecToUse = hierarchical ? hierarchicalBlotterVariantSpecs : rowGroupBlotterVariantSpecs;

  return { blotterSpecToUse };
}
